import { Component, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { PaginationInformation } from 'app/models';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnChanges {

  //public pages: Array<number>;

  @Input()
  public disabled: boolean;

  @Input()
  public paginationInformation: PaginationInformation;

  @Output()
  public pageChange = new EventEmitter<number>();

  constructor() {
    this.disabled = false;
    //this.pages = new Array<number>();
    this.paginationInformation = new PaginationInformation();
  }

  ngOnChanges() {
    //this.pages = new Array<number>();
    // if (this.paginationInformation == undefined || this.paginationInformation == null)
    //   this.paginationInformation = new PaginationInformation();
    // const start = this.paginationInformation.CurrentPage <= 3 ?
    //   1 : this.paginationInformation.CurrentPage - 3;
    // const end = this.paginationInformation.CurrentPage + 7 > this.paginationInformation.PageCount ?
    //   this.paginationInformation.PageCount : this.paginationInformation.CurrentPage + 7;

    // for (let i = start; i <= end; i++) {
    //   this.pages.push(i);
    // }
  }

  public changePage(pageNumber: number): void {
    //if (this.paginationInformation.CurrentPage != pageNumber) {
    this.pageChange.emit(pageNumber);
    //}
  }
}